// Light Mode Color Foundation

export default {
   // Global
   globalNavLogoFieldName: 'logoDefault',
   listItemTitleTextColor: '#111',
   tmpBackgroundColor: '#fff',
   tmpBodyTextColor: '#666',
   tmpFooterBackgroundColor: '#eee',
   // Aside
   tmpAsideBodyTextColor: '#777',
   tmpAsideButtonActiveBackgroundColor: '#eee',
   tmpAsideButtonActiveTextColor: '#000',
   tmpAsideButtonTextColor: '#666',
   tmpAsideLineColor: '#f3f3f3',
   tmpAsideTitleColor: '#222',
   // Content
   tmpContentBackgroundColor: '#fff',
   tmpContentLineColor: '#eee',
   tmpContentTitleColor: '#333',
   // Main Menu
   tmpMainMenuBackgroundColor: '#fff',
   tmpMainMenuBorderColor: '#f3f3f3',
   tmpMainMenuButtonTextColor: '#444',
   tmpMainMenuButtonActiveTextColor: '#000',
   tmpMainMenuButtonActiveBackgroundColor: '#f3f3f3',
   tmpMainMenuLineColor: '#f3f3f3',
   tmpMainMenuSearchBackgroundColor: '#eee',
   tmpMainMenuTextColor: '#777',
   tmpMainMenuTitleColor: '#333',
   // Will change
   tmpBorderColor: '#e5e5e5',
   tmpColumnBorderColor: 'rgb(244, 240, 240)'
}
